import { defineMessages } from 'react-intl';

export default defineMessages({
  homePageTitle: {
    id: 'home_page.title',
  },
  homePageSubTitle: {
    id: 'home_page.subtitle',
  },
  homePagePreOpeningButton: {
    id: 'home_page.preopening_button',
  },
});
